import React, { useCallback, useEffect, useState } from 'react'
import axios from '@fs/zion-axios'
import { NoticeLoading } from '@fs/zion-icon/dist/cjs/icons'
import { getSessionUserId } from '../../services/userService'
import { setUserPreferredRole } from '../../services/userPreferencesService'

export default function Spinner() {
  const [requestCount, setRequestCount] = useState(0)

  const spinnerCss = {
    position: 'fixed',
    top: '50%',
    insetInlineStart: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
    visibility: requestCount > 0 ? 'visible' : 'hidden',
  }

  const handleSessionDeElevation = useCallback(async () => {
    const sessionUserIdResponse = await getSessionUserId()
    const userId = sessionUserIdResponse.data.userId
    await setUserPreferredRole('', userId)
  }, [])

  useEffect(() => {
    const { REACT_APP_DMC_SERVER } = process.env
    const axiosRequestInterceptor = axios.interceptors.request.use(
      async (req) => {
        if (!(req.url.includes('/service/dmc/odv') && req.url.includes('/qsize'))) {
          setRequestCount((prevState) => prevState + 1)
        }

        // Set baseUrl to localhost if we are running local server
        // Only for those URLs that go through dmconsole server
        if (REACT_APP_DMC_SERVER === 'localhost') {
          if (req.url.includes('/service/dmc', '')) {
            req.baseURL = 'http://localhost:8080'
            req.url = req.url.replace('/service/dmc', '')
          }
        }
        if (req.method === 'delete' && req.url.includes('/auth/session')) {
          await handleSessionDeElevation()
        }
        return req
      },
      (err) => {
        if (!(err.config.url.includes('/service/dmc/odv') && err.config.url.includes('/qsize'))) {
          setRequestCount((prevState) => prevState - 1)
        }
        return Promise.reject(err)
      }
    )
    return () => {
      axios.interceptors.request.eject(axiosRequestInterceptor)
    }
  }, [handleSessionDeElevation])

  useEffect(() => {
    const axiosResponseInterceptor = axios.interceptors.response.use(
      (res) => {
        if (!(res.config.url.includes('/service/dmc/odv') && res.config.url.includes('/qsize'))) {
          setRequestCount((prevState) => prevState - 1)
        }
        return res
      },
      (err) => {
        if (!(err.config.url.includes('/service/dmc/odv') && err.config.url.includes('/qsize'))) {
          setRequestCount((prevState) => prevState - 1)
        }
        return Promise.reject(err)
      }
    )
    return () => {
      axios.interceptors.request.eject(axiosResponseInterceptor)
    }
  }, [])

  return (
    <span id="spinner" style={spinnerCss}>
      <NoticeLoading size="lg" />
    </span>
  )
}
